import { Button, makeStyles, List, ListItem, Box, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { member as v_member, basic, Values, oper as v_oper } from '../request/values';

import React, { Fragment, useState } from "react";
import { COLORS } from './Theme'

import { useSnackbar } from 'notistack';
import ToastStr from '../request/toastStr';
import { TitleBackBar2 } from "./header/TitleBar";
import DialogConfirm, { DialogInput, DialogInputText } from "./Dialog";
import { useCookies } from "react-cookie";

const useStyles = makeStyles((theme) => ({
    box: {
        marginTop: '2vh',
        [theme.breakpoints.up("md")]: {
          marginTop:'0px'
        },
    },
    list: {
        padding: 0,
        width: '100vw',
        //margin: '3vw',
        height: '73vh',
        overflowY: 'auto',
        ...theme.typography.subtitle1,
        color: `${COLORS.BROWNISH_GREY}`,
        [theme.breakpoints.up("md")]: {
          height: '100%',
          ...theme.typography.subtitle1,
        },
    },
    listItem: {
        borderRadius: 5,
        border: 'solid 1px #d3d3d3',
        boxShadow: '1px 0px 6px 0 rgba(0, 0, 0, 0.16)',
  
        width: '94%',
        margin: '3vw',
        paddingLeft: '2.5vw',
        paddingRight: '2.5vw',
        paddingTop: '2.2vh',
        paddingBottom: '2.2vh',
    },
    manualSize: {
        width: '60vw',
        heigth: '6vh',
        //marginLeft: '14.5vw',
        marginBottom: '1vh',
        marginTop: '1vh',
    },
    toastSize: {
        width: '60vw',
        heigth: '6vh',
        //marginLeft: '14.5vw',
        marginBottom: '1vh',
        marginTop: '1vh',
    },
    whiteSize: {
        width: '50%',
        border: '0.5px solid',
        marginTop: '0.5vh',
        marginBottom: '0.5vh',
    },
    translateSize: {
        width: '100%',
        border: '0.5px solid',
        marginTop: '0.5vh',
        marginBottom: '0.5vh',
    },
    translateZoomSize: {
        width: '100%',
        border: '0.5px solid',
        marginTop: '0.5vh',
        marginBottom: '0.5vh',
    },

    logoSection: {
        display: 'flex',
        flex: 1,
        width: '100%',
        alignItems: 'flex-end',
        paddingBottom: '5vh',
    },
    logo: {
        width: '5.5vw',
        maxWidth: "35px"
    },
}));

const SERVER = basic.server;


const QnA: React.FC<any> = props => {
    const classes = useStyles();
    let history = useHistory();

    const { member, setMember, deleteMember } = props
 
    return (
        <>
            <TitleBackBar2 history={history} title="QnA" titleIcon="question" />

            <Box className={classes.box} display="grid" justifyContent="center" alignItems="center" >
                <List className={classes.list}>
                    <ListItem className = {classes.listItem}>
                        <Typography variant="subtitle1">
                            앱 사용중 생기는 문제를 해결하기 위한 페이지입니다.
                            <br/>
                            여기서 해결되지 않는 문제를 발견하면 질문해주세요.
                        </Typography>
                    </ListItem>
                    <ListItem className = {classes.listItem}>
                        <details>
                            <summary>
                                처음에 무엇부터 할지 모르겠어요. (제조기업)
                            </summary>
                            <Typography>
                                <br />
                                1. 연구개발에서 프로젝트를 진행해 주세요.
                                <br />
                                <img className={classes.manualSize} src='/images/qna/manual_man1.png' />
                                <br />
                                2. 제품생산에서 설명서와 재료 목록을 확인해요.
                                <br />
                                <img className={classes.manualSize} src='/images/qna/manual_man2.png' />
                                <br />
                                3. 재료구매에서 확인한 재료 목록을 구매해 주세요.
                                <br />
                                <img className={classes.manualSize} src='/images/qna/manual_man3.png' />
                                <br />
                                4. 구매한 재료가 도착하면 설명서를 보고 제품을 만들어 판매하세요.
                                <br />
                                <img className={classes.manualSize} src='/images/qna/manual_man4.png' />
                                <br />
                                위와 같은 방식으로 각자의 전략을 세워 진행해 주세요.

                            </Typography>
                        </details>
                    </ListItem>
                    <ListItem className = {classes.listItem}>
                        <details>
                            <summary>
                                처음에 무엇부터 할지 모르겠어요. (유통기업)
                            </summary>
                            <Typography>
                                <br />
                                1. 제조기업에서 재료를 요청할 때까지 잠시 기다려줘요.
                                <br />
                                2. 재료 요청이 오면 재료를 담아 제조기업한테 전달해줘요.
                                <br />
                                <img className={classes.manualSize} src='/images/qna/manual_dis1.png' />
                                <br />
                                3. 제품 판매 요청이 오면 재정 상태를 보고 제품을 구매해줘요.
                                <br />
                                <img className={classes.manualSize} src='/images/qna/manual_dis2.png' />
                                <br />
                                4. 구매한 제품을 다 분해하였으면 선생님한테 분해 완료 신청을 해요.
                                <br />
                                <img className={classes.manualSize} src='/images/qna/manual_dis3.png' />
                                <br />
                                위와 같은 방식으로 각자의 전략을 세워 진행해 주세요.

                            </Typography>
                        </details>
                    </ListItem>
                    <ListItem className = {classes.listItem}>
                        <details>
                            <summary>
                                알림창 색깔별 설명
                            </summary>
                            <Typography>
                                <img className={classes.toastSize} src='/images/qna/toast_success.png' />
                                <br />
                                초록색 알림창은 동작이 정상적으로 처리된 것입니다.
                                <br />
                                <img className={classes.toastSize} src='/images/qna/toast_warning.png' />
                                <br />
                                주황색 알림창은 사용자가 무엇을 잘못한 것입니다.
                                <br />
                                ex) 회사의 현금 자산 부족, 제품의 재료 부족
                                <br />
                                <img className={classes.toastSize} src='/images/qna/toast_error.png' />
                                <br />
                                빨간색 알림창은 인터넷 연결이 불안한 경우입니다.
                                <br />
                                잠시 후 다시 시도 해보세요.
                                <br />
                            </Typography>
                        </details>
                    </ListItem>
                    <ListItem className = {classes.listItem}>
                        <details>
                            <summary>
                                흰색 페이지에서 반응이 없어요
                            </summary>
                            <Typography>
                            <img className={classes.whiteSize} src='/images/qna/white_page.png' />
                            <div>
                                만약 이런 하얀 화면이 뜬다면 앱을 완전히 종류 후 재접속 해주세요.
                            </div>
                        </Typography>
                        </details>
                    </ListItem>
                    <ListItem className = {classes.listItem}>
                        <details>
                            <summary>
                                한글이 이상하게 떠요
                            </summary>
                            <Typography>
                            <img className={classes.translateSize} src='/images/qna/translate_error.png' />
                            <img className={classes.translateZoomSize} src='/images/qna/translate_error_zoom.png' />
                            <div>1. 웹사이트 주소 옆의 번역 표시를 눌러주세요.</div>
                            <div>2. 한글에서 영어로 번역을 변경해주세요.</div>
                            <div>* 어디서 이상하게 보이는지 선생님께 알려줘요</div>
                        </Typography>
                        </details>
                    </ListItem>
                </List>
            </Box>

            <div className={classes.logoSection}>
                <div style={{flexDirection: 'column', width: '100vw'}}>
                    <div style={{textAlign: 'center', marginLeft: 'auto'}}>
                        <img className={classes.logo} src='/images/p.webp' />
                    </div>
                </div>
            </div>

            
        </>

    )
}

export default QnA;